import vuexHelpers from "../helpers/vuex.helpers";
import userModule from "./user.module";
import userService from "../services/user.service";

const getInitialState = function () {
  return {
    search: null,
    tableLoading: false,
    tableParams: {},
    removeUserDialog: false
  };
};

const initialState = getInitialState();
const getters = {};

const actions = {
  async loadTableData({ commit, dispatch, state }) {
    let task = await dispatch(
      "app/addLoadingTask",
      "Caricamento dati tabella users",
      {
        root: true,
      }
    );
    state.tableLoading = true;
    try {
      await dispatch("users/table", {
        tableParams: state.tableParams,
        search: state.search
      });
    } catch (error) {
      await dispatch(
        "app/addAlert",
        {
          text: error,
        },
        { root: true }
      );
    }
    commit("app/removeLoadingTaskById", task.id, { root: true });
    state.tableLoading = false;
  },
  async save({ commit, dispatch }, data) {
    let task = await dispatch(
      "app/addLoadingTask",
      "Salvataggio permessi",
      {
        root: true,
      }
    );

    try {
      const res = await userService.save(data);

      if (res.isError)
        throw "Errore nel salvataggio dell'utente";

      await dispatch("loadTableData");
    } catch (error) {
      await dispatch(
        "app/addAlert",
        {
          text: error,
        },
        { root: true }
      );
    }
    commit("app/removeLoadingTaskById", task.id, { root: true });
  },
}

const mutations = {};

const filesViewModule = {
  namespaced: true,
  state: initialState,
  modules: {
    users: userModule,
  },
  actions: { ...actions },
  getters: {
    ...getters,
  },
  mutations: {
    ...vuexHelpers.mutations(getInitialState),
    ...vuexHelpers.tableMutations(getInitialState),
    ...mutations,
  },
};

export default filesViewModule;
